import styled from 'styled-components';
import { media } from '@minecraft.themes';
import Icon from '@minecraft.icon';
import CloudinaryPhoto from '@minecraft.cloudinary-photo';
import { PageWrapperStyles } from '../../../common/styles';

export const ContentWrapper = styled.div`
  ${PageWrapperStyles}

  margin: 1rem 0;
  flex: 1 0 auto;
`;

export const Title = styled.h2`
  font-size: 1.25rem;
  color: ${(props): string => props.theme.colors.primary.white};
  font-weight: 500;
  margin: 0;
`;

export const SubmissionNoteContainer = styled.div`
  margin-top: 1rem;
  color: ${(props): string => props.theme.colors.primary.white};
`;

export const SubmissionNote = styled.p`
  margin-top: 0.5rem;
`;

export const StyledCloudinaryPhoto = styled(CloudinaryPhoto)`
  max-width: 100%;
`;

export const StyledArrowButton = styled.button<{ $left?: boolean; $right?: boolean }>`
  background-color: transparent;
  border: none;
  outline: none;
  padding: 0;
  position: absolute;
  top: 0;
  bottom: 2rem;
  display: none;
  justify-content: center;
  z-index: 1;
  transition: background-color 0.25s;
  align-items: center;

  ${(props) => props.$left && `left: 0;`}
  ${(props) => props.$right && `right: 0;`}

  &:hover,
  &:focus {
    background-color: rgba(0, 0, 0, 0.3);
  }

  ${media.sm`
    display: flex;
  `}
`;

export const ThickIcon = styled(Icon)`
  height: 1rem;
  width: 1rem;
  margin: auto;
`;
